window._ = require('lodash');

window.$ = window.jQuery = require('jquery');
require('bootstrap');
window.$ = $.extend(require('jquery-ui'));

window.select2 = require('select2');
//require('daterangepicker');
const flatpickr = require("./libs/flatpickr/flatpickr.min");

window.flatpickr = flatpickr;

// Add google map script if not exist; if exist, return true
window.checkAndAttachMapScript = function (callback) {
    if (!!window.google) {  // If you're using vue cli, then directly checking
        // 'google' obj will throw an error at the time of transpiling.
        callback();
        return true;
    }

    window.mapApiInitialized = callback;
    let script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${window.MIX_GOOGLE_KEY}&libraries=places,geometry,visualization&callback=mapApiInitialized`;
    document.body.appendChild(script);
}

checkAndAttachMapScript((x) => {
    console.log("Map initialized")
});

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.withCredentials = true;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Accept'] = 'application/json';
window.axios.defaults.headers.common['Content-Type'] = 'application/json';

$(document).ready(function() {
    $("#go1").click(function() {
        let percent1 = $("#percent1").val();
        let amount1 = $("#amount1").val();
        if(!isNaN(percent1) && !isNaN(amount1)){

            let result = (amount1/100) * percent1;
            $("#result1").html(result.toFixed(2));
        }
    });

    $("#go2").click(function() {
        let percent2 = $("#percent2").val();
        let amount2 = $("#amount2").val();
        if(!isNaN(percent2) && !isNaN(amount2)){

            let result = (percent2/amount2) * 100;
            $("#result2").html(result.toFixed(0) + "%");
        }
    });

    $("#go3").click(function() {
        let original_amount = $("#original_amount").val();
        let new_amount = $("#new_amount").val();
        if(!isNaN(original_amount) && !isNaN(new_amount)){
            let increase = new_amount - original_amount;
            let result = (increase / original_amount) * 100;
            $("#result3").html(result.toFixed(0) + "%");
        }
    });

    $('textarea').keypress(function(event) {
        if (event.which == 13) {
            event.preventDefault();
            var s = $(this).val();
            $(this).val(s+"\n");
        }
    });

    $("textarea").each(function(textarea) {
         if ($(this).hasClass("address-box")) {
            
        }
        else{

             $(this).height(0);
             $(this).height( $(this)[0].scrollHeight);
        }

       
    });

    $('textarea').on('keyup keypress', function() {
        $(this).height(0);
        $(this).height(this.scrollHeight);
    });
});


/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
